<div class="scene-thumbnail__wrapper">
  @if (hasImage()) {
    <ocp-image
      class="scene-thumbnail__backdrop"
      [src]="resolvedThumbnailUrl()!"
      imgClass="scene-thumbnail__backdrop-image"
      alt=""
      ariaHidden="true"
      aria-hidden="true"
      [optimized]="!isDataUrl()"
      [priority]="priority()"
      [fill]="!isDataUrl()"
    />
    <ocp-image
      class="scene-thumbnail__foreground"
      [src]="resolvedThumbnailUrl()!"
      imgClass="scene-thumbnail__image"
      [alt]="alt()"
      [optimized]="!isDataUrl()"
      [priority]="priority()"
      [fill]="!isDataUrl()"
    />
  } @else {
    <div class="scene-thumbnail__placeholder">
      <ocp-themed-icon
        name="thumbnail-placeholder.svg"
        [size]="24"
        class="scene-thumbnail__placeholder-icon"
      />
      <span class="scene-thumbnail__placeholder-text">{{
        'scene-thumbnail.no-scene' | translate
      }}</span>
    </div>
  }
  <div class="scene-thumbnail__actions">
    <ng-content />
  </div>
</div>
